export interface ContextualHelpCopy {
  title: string;
  tips: string[];
}

const DEFAULT_HELP: ContextualHelpCopy = {
  title: 'Tips',
  tips: [
    'Press ⌘K / Ctrl+K to search patients, appointments, and invoices.',
    'Use Create for common tasks without leaving the page.',
    'Queue shows who is checked in and waiting.',
  ],
};

const BY_NAV_LABEL: Record<string, ContextualHelpCopy> = {
  Patients: {
    title: 'Patients',
    tips: [
      'Search by name or phone from the header to open a chart quickly.',
      'Use Create → New patient when registering walk-ins.',
      'Recall and referrals live under Patients in the sidebar.',
    ],
  },
  Appointments: {
    title: 'Appointments',
    tips: [
      'Set the working day in the header to align calendar, list, and queue.',
      'Next shows the soonest upcoming visit — click to open it.',
      'Waiting room tracks checked-in patients ready for chair.',
    ],
  },
  Billing: {
    title: 'Billing',
    tips: [
      'Create → New invoice starts a draft without leaving context.',
      'Search invoices and patients from ⌘K / Ctrl+K.',
      'Money is always tracked in paise — amounts display as ₹.',
    ],
  },
  Clinical: {
    title: 'Clinical',
    tips: [
      'Dental chart editing is available on web for clinical documentation.',
      'Consent forms and lab orders are under Clinical in the sidebar.',
      'Open the patient chart from search before starting chairside work.',
    ],
  },
  Dashboard: {
    title: 'Dashboard',
    tips: [
      'Waiting and today’s counts summarize floor status at a glance.',
      'Jump to waiting room from the Queue control in the header.',
      'Use Create for booking and registration shortcuts.',
    ],
  },
};

/**
 * Resolves short, non-PHI tips for the active nav area.
 */
export function resolveContextualHelp(navLabel: string | null | undefined): ContextualHelpCopy {
  if (!navLabel) return DEFAULT_HELP;
  return BY_NAV_LABEL[navLabel] ?? DEFAULT_HELP;
}
